/**
 * Send as a gift: fields, sticky ATC sync/disable, collapsible Done.
 */
(function () {
  function eachNode(list, callback) {
    Array.prototype.forEach.call(list || [], callback);
  }

  function syncCheckbox(mainCb, stickyCb) {
    if (stickyCb) {
      stickyCb.checked = mainCb.checked;
    }
  }

  function syncField(from, to) {
    if (from && to) {
      to.value = from.value;
    }
  }

  function getStickySubmit(stickyFormId) {
    var form = document.getElementById(stickyFormId);
    if (!form) {
      return null;
    }
    return form.querySelector('button.hdt-sticky-atc__submit') || form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
  }

  function pruneStickyInputsIfNoForm(root, stickyFormId) {
    if (document.getElementById(stickyFormId)) {
      return;
    }
    eachNode(root.querySelectorAll('[data-send-gift-sticky-cb], [data-send-gift-sticky-field]'), function (el) {
      el.remove();
    });
  }

  function validateGiftInputs(fieldsEl, validationMsgEl, validationRequiredText) {
    var ctrls = fieldsEl.querySelectorAll('input:not([type="hidden"]), textarea, select');
    var ok = true;
    var i = 0;
    if (validationMsgEl) {
      validationMsgEl.hidden = true;
      validationMsgEl.textContent = '';
    }
    for (i = 0; i < ctrls.length; i++) {
      var el = ctrls[i];
      if (!fieldsEl.contains(el) || fieldsEl.hidden) {
        continue;
      }
      if (typeof el.checkValidity !== 'function') {
        continue;
      }
      if (!el.checkValidity()) {
        el.reportValidity();
        ok = false;
        try {
          el.focus({ preventScroll: false });
        } catch (e0) {}
        try {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e1) {}
        if (validationMsgEl) {
          validationMsgEl.textContent =
            validationRequiredText ||
            'Please complete the required fields before confirming.';
          validationMsgEl.hidden = false;
        }
        break;
      }
    }
    return ok;
  }

  function init(root) {
    var mode = root.dataset.sendGiftMode || 'sync';
    var stickyFormId = root.dataset.stickyFormId;
    var stickyAtc = root.dataset.stickyAtc === 'true';
    var mainCb = root.querySelector('[data-send-gift-main-cb]');
    var fieldsEl = root.querySelector('[data-send-gift-fields]');
    var mainFields = root.querySelectorAll('[data-send-gift-main-field]');
    var stickyCb = root.querySelector('[data-send-gift-sticky-cb]');
    var stickyFields = root.querySelectorAll('[data-send-gift-sticky-field]');
    var hint = root.querySelector('[data-send-gift-sticky-hint]');
    var bannerStatus = root.querySelector('[data-send-gift-details-status]');
    var bannerEdit = root.querySelector('[data-send-gift-edit]');
    var bannerToggle = root.querySelector('[data-send-gift-banner-toggle]');
    var bannerRow = root.querySelector('[data-send-gift-banner-row]');
    var validationMsgEl = root.querySelector('[data-send-gift-validation-msg]');
    var validationRequiredText = (root.dataset.sendGiftValidationRequiredMsg || '').trim();
    var doneBtn = root.querySelector('[data-send-gift-done]');
    var cancelBtn = root.querySelector('[data-send-gift-cancel]');
    var collapseEnabled = !!doneBtn;

    if (!mainCb || !fieldsEl) {
      return;
    }

    pruneStickyInputsIfNoForm(root, stickyFormId);
    eachNode(mainFields, function (field) {
      if (field.required) {
        field.dataset.requiredConfig = 'true';
      }
    });

    function getStickyFieldByProp(prop) {
      return root.querySelector('[data-send-gift-sticky-field="' + prop + '"]');
    }

    function setFieldActive(field, active) {
      if (!field) {
        return;
      }
      var propName = field.dataset.propName || field.getAttribute('name');
      if (active && propName) {
        field.setAttribute('name', propName);
      } else {
        field.removeAttribute('name');
      }
    }

    function applyRequired(el, shouldRequire) {
      if (!el) {
        return;
      }
      if (el.dataset.requiredConfig === 'true') {
        el.required = !!shouldRequire;
      }
    }

    function setStickyDisabled(disabled) {
      if (!stickyAtc || mode !== 'disable') {
        return;
      }
      var btn = getStickySubmit(stickyFormId);
      if (btn) {
        btn.disabled = !!disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
      if (hint) {
        hint.hidden = !disabled;
      }
    }

    function syncAllFields() {
      syncCheckbox(mainCb, stickyCb);
      eachNode(mainFields, function (field) {
        var propName = field.dataset.propName;
        if (!propName || !field.getAttribute('name')) {
          return;
        }
        var stickyField = getStickyFieldByProp(propName.replace('properties[', '').replace(']', ''));
        if (!stickyField) {
          return;
        }
        syncField(field, stickyField);
      });
    }

    function clearAllFields() {
      eachNode(mainFields, function (field) {
        field.value = '';
      });
      eachNode(stickyFields, function (field) {
        field.value = '';
      });
    }

    /** Native required toggles: off when collapsed/unchecked so add-to-cart can submit. */
    function refreshRequired(expandedGift) {
      if (!mainCb.checked || !expandedGift) {
        eachNode(mainFields, function (field) {
          applyRequired(field, false);
        });
        return;
      }
      eachNode(mainFields, function (field) {
        applyRequired(field, field.dataset.requiredConfig === 'true');
      });
    }

    function syncBannerAria() {
      if (!bannerToggle) {
        return;
      }
      var on = mainCb.checked;
      var collapsed =
        collapseEnabled && root.getAttribute('data-send-gift-collapsed') === 'true';
      var expandedGift = !!on && (collapseEnabled ? !collapsed : true);
      bannerToggle.setAttribute('aria-expanded', expandedGift ? 'true' : 'false');
    }

    /** Only after a successful Confirm (Done): show “gift details added” + Edit. */
    function giftConfirmed() {
      return root.getAttribute('data-send-gift-confirmed') === 'true';
    }

    function updateUi() {
      var on = mainCb.checked;
      var collapsed =
        collapseEnabled && root.getAttribute('data-send-gift-collapsed') === 'true';
      var expandedGift = !!on && (collapseEnabled ? !collapsed : true);
      var showCompletedChrome = !!(on && collapsed && giftConfirmed());

      fieldsEl.hidden = !expandedGift;

      if (collapseEnabled && bannerStatus) {
        bannerStatus.hidden = !showCompletedChrome;
      } else if (bannerStatus) {
        bannerStatus.hidden = true;
      }

      if (collapseEnabled && bannerEdit) {
        bannerEdit.hidden = !showCompletedChrome;
      }

      if (on) {
        eachNode(mainFields, function (field) {
          setFieldActive(field, true);
        });
        refreshRequired(expandedGift);
        syncAllFields();
        if (mode === 'disable') {
          setStickyDisabled(true);
        }
      } else {
        root.removeAttribute('data-send-gift-collapsed');
        root.removeAttribute('data-send-gift-confirmed');
        eachNode(mainFields, function (field) {
          setFieldActive(field, false);
        });
        refreshRequired(false);
        clearAllFields();
        if (stickyCb) {
          stickyCb.checked = false;
        }
        if (mode === 'disable') {
          setStickyDisabled(false);
        }
        fieldsEl.hidden = true;
        if (bannerStatus) {
          bannerStatus.hidden = true;
        }
        if (bannerEdit) {
          bannerEdit.hidden = true;
        }
      }
      syncBannerAria();
    }

    function activateBannerFromHit() {
      if (!mainCb.checked) {
        mainCb.checked = true;
        mainCb.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      if (!collapseEnabled) {
        if (!fieldsEl.hidden) {
          try {
            fieldsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch (e2) {}
        }
        return;
      }
      var collapsed = root.getAttribute('data-send-gift-collapsed') === 'true';
      if (collapsed) {
        root.removeAttribute('data-send-gift-collapsed');
      } else {
        root.setAttribute('data-send-gift-collapsed', 'true');
      }
      updateUi();
    }

    mainCb.addEventListener('change', function () {
      if (!mainCb.checked) {
        root.removeAttribute('data-send-gift-collapsed');
        root.removeAttribute('data-send-gift-confirmed');
      }
      updateUi();
    });

    function shouldIgnoreBannerRowClick(evt) {
      var t = evt.target;
      if (!t) {
        return true;
      }
      if (bannerEdit && (t === bannerEdit || bannerEdit.contains(t))) {
        return true;
      }
      return false;
    }

    if (bannerRow) {
      bannerRow.addEventListener('click', function (evt) {
        if (shouldIgnoreBannerRowClick(evt)) {
          return;
        }
        activateBannerFromHit();
      });
    }

    if (bannerToggle) {
      bannerToggle.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Enter' && evt.key !== ' ') {
          return;
        }
        evt.preventDefault();
        activateBannerFromHit();
      });
    }

    eachNode(mainFields, function (field) {
      var propName = field.dataset.propName;
      if (!propName) {
        return;
      }
      field.addEventListener('input', function () {
        if (validationMsgEl) {
          validationMsgEl.hidden = true;
          validationMsgEl.textContent = '';
        }
        syncAllFields();
      });
      field.addEventListener('change', syncAllFields);
    });

    if (doneBtn) {
      doneBtn.addEventListener('click', function () {
        if (!mainCb.checked) {
          return;
        }
        if (!validateGiftInputs(fieldsEl, validationMsgEl, validationRequiredText)) {
          return;
        }
        root.setAttribute('data-send-gift-confirmed', 'true');
        root.setAttribute('data-send-gift-collapsed', 'true');
        updateUi();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        root.removeAttribute('data-send-gift-collapsed');
        root.removeAttribute('data-send-gift-confirmed');
        mainCb.checked = false;
        mainCb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (bannerEdit) {
      bannerEdit.addEventListener('click', function (evt) {
        evt.stopPropagation();
        root.removeAttribute('data-send-gift-collapsed');
        updateUi();
      });
    }

    if (mode === 'sync' && stickyAtc) {
      var stickyForm = document.getElementById(stickyFormId);
      if (stickyForm) {
        stickyForm.addEventListener(
          'submit',
          function () {
            syncAllFields();
          },
          true
        );
      }
    }

    updateUi();
  }

  function boot() {
    document.querySelectorAll('[data-send-gift-root]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
